import { postSalesCenter } from '@/api/company'

const handleError=(url,id)=>{
  console.log(url,id+':错误信息')
}
export default {
  postSalesCenter({commit}, [parmas,fn]) {
    postSalesCenter(parmas).then(res => {
      res=JSON.parse(JSON.stringify(res))
      let data = res.data;
      if(typeof (data)!='object' || typeof (data)=="undefined") {
        var myData={
          code:-1
        }
        commit('fillToPageMeetingList',myData);
        //设置顶级mate信息
        commit('setArtistHomeMeta', myData, {root: true})
        console.log("getAucMeet->Meta=>未正确请求接口数据");
      }else{
        commit('fillToPageMeetingList',data);
        //设置顶级mate信息
        commit('setArtistHomeMeta', data, {root: true})
      }
      if(fn!=undefined) fn()
    }).catch(err => {
      console.log(err);
      handleError("getMeetingList",parmas);
    })
  }
}